<style>
@import '../../custom/css/admin-navigation.css';
</style>

<template>
  <div class="representantes">
    <div class="row m-0">
      <div class="col-lg-3 col-md-3 col-sm-12 col-12 p-0 bg-gray-1">
        <div class="menu-area-restrita">
          <Topic :text="'Informações'" :icon="'fas fa-user-circle'" />
          <BasicItem
            :text="'Meus Dados'"
            :icon="'fas fa-list-alt'"
            :routeName="'representante-meus-dados'"
          />
          <BasicItem
            :text="'Sair'"
            :icon="'fas fa-power-off'"
            :routeName="'sair'"
          />

          <!-- Fim dos Meus Dados -->

          <Topic
            class="mt-4"
            :text="'Cotações'"
            :icon="'fas fa-clipboard-list'"
          />
          <Item
            :icon="'fas fa-paper-plane'"
            :count="cotacoesContagem.recebidas"
            :pushToRouteName="'representante-recebidas'"
            :itemText="'Recebidas'"
            :iconStyle="'transform: rotate(190deg)'"
          />

          <Item
            :icon="'fas fa-paper-plane'"
            :count="cotacoesContagem.enviadas"
            :pushToRouteName="'representantes-enviadas'"
            :itemText="'Enviadas'"
            :iconStyle="'transform: rotate(15deg)'"
          />

          <Item
            :icon="'fas fa-trophy'"
            :count="cotacoesContagem.ganahs"
            :pushToRouteName="'representante-ganhas'"
            :itemText="'Ganhas'"
          />

          <Item
            :icon="'fas fa-check-square'"
            :count="cotacoesContagem.completas"
            :pushToRouteName="'representante-completas'"
            :itemText="'Completas'"
          />

          <Item
            :icon="'fas fa-calendar-times'"
            :count="cotacoesContagem.perdidas"
            :pushToRouteName="'representante-perdidas'"
            :itemText="'perdidas'"
          />

          <!-- Começo Cotações Rejeitadas -->

          <Topic
            class="mt-4"
            :text="'Cotações Rejeitadas'"
            :icon="'fas fa-times-circle'"
          />
          <Item
            :icon="'fas fa-thumbs-down'"
            :count="cotacoesContagem.rejeitadasPU"
            :pushToRouteName="'representante-rejeitadas-pelo-usuario'"
            :itemText="'Por você'"
          />

          <Item
            :icon="'fas fa-times'"
            :count="cotacoesContagem.rejeitadasPL"
            :pushToRouteName="'representante-rejeitadas-pelos-lojistas'"
            :itemText="'Pelos Lojistas'"
          />
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-sm-12 col-12 p-0">
        <div class="conteudo-area-restrita">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Item from '../../components/Menu/Item.vue';
import Topic from '../../components/Menu/Topic.vue';
import BasicItem from '../../components/Menu/BasicItem.vue';

export default {
  name: 'representantes',
  components: {
    Item,
    Topic,
    BasicItem,
  },
  computed: {
    ...mapGetters([
      // Mapeamento de getters
    ]),
    ...mapState({
      // Mapeamento de states
      token: (state) => state.token,
      dadosUsuario: (state) => state.dadosUsuario,
      cotacoesContagem: (state) => state.cotacoesContagem,
    }),
  },
  data: () => ({
    isSlowCotacao: true,
    isSlowDados: true,
  }),
  watch: {
    $route() {
      this.contagemCotacoes();
    },
  },
  created() {
    if (this.dadosUsuario) {
      this.contagemCotacoes();
    }
  },
  methods: {
    contagemCotacoes() {
      this.$store.dispatch('showContagemCotacoes', this.dadosUsuario);
    },
  },
};
</script>
